module.exports = __webpack_public_path__ + "img/gerüstbohlen-tisch-konfigurator.2ad41a5a.jpeg";